import { cookieGet } from '@/common/cookie';
import { RawResponse } from '@/common/declare';
import request from "@/plugin/axios";
import { MenuDescriptor } from '../../declare';
import { RoleDescriptor } from './declare';

export function getMenu(): Promise<RawResponse<MenuDescriptor>> {
    return request({
        /* url: '/Admin/getMyMenu',
        method: 'POST',
        data: {
            limit: 0,
        } */
        url: '/v1/pico/menu/nav/list/manager',
        method: 'GET',
        params: {
            token: cookieGet('token')
        }
    }).then((res: any) => {
        // 注意,路由排序功能放在这里了,由于没有改变整体结构,这里就作为默认输出而不写在转换函数内
        const sortFun = (a, b) => {
            if (typeof a.sort !== 'number' || typeof b.sort !== 'number') {
                return 0;
            }
            return a.sort - b.sort;
        };
        res.list.sort(sortFun);

        for (let item of res.list) {
            if (item.menuList instanceof Array) {
                item.menuList.sort(sortFun);
            }
        }
        
        return res.list
    })
}

export function delMenu(id: string | string[]) {
    const condElements = typeof id === 'string' ? [{
        key: 'menuId',
        flag: '=',
        value: id
    }] : [{
        key: 'menuId',
        flag: 'in',
        value: '("' + id.join('","') + '")'
    }];
    
    return request({
        url: '/Menu/del',
        method: 'POST',
        data: {
            condition: {
                condElements
            },
            limit: 1
        }
    })
}

/**
 * 根据当前role获取MenuList,返回一个树状结构
 */
export function getRoleMenuRelationList(): Promise<RoleDescriptor[]> {
    return request({
        url: '/Role/getListWithRelation',
        method: 'POST',
        data: {
            limit: 0,
        }
    }).then((res: any) => {
        return res.data;
    })
}

/**
 * 保存指定的角色配置,对menuList采用覆盖操作
 * @param role 角色配置
 */
export function saveRole(role: RoleDescriptor) {
    return request({
        url: '/Role/doSaveWithRelation',
        method: 'POST',
        data: role,
    })
}

/**
 * 删除动态路由(新版)
 * @param id 路由id
 */
export function removeDynamicRouteById(id: string): Promise<Response> {
    return fetch(`${process.env.VUE_APP_API}/Menu/del`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            token: cookieGet('token'),
        },
        body: JSON.stringify({
            condition: {
                condElements: [
                    {
                        key: 'menuId',
                        value: id,
                    }
                ],
                flag: '='
            },
            limit: 1,
        }),
    })
}

/**
 * 添加动态路由,是测试函数
 * @param routeObj 路由对象
 */
export function postRoute(routeObj: MenuDescriptor): Promise<MenuDescriptor> {
    return request({
        url: '/Menu/doSaveWithRelation',
        method: 'POST',
        data: routeObj
    }).then(res => res.data);
}

